<div class="card" data-qa-id="Order Complete Intake Link">
  <div class="card-content">
    <div class="is-flex is-align-items-center mb-2">
      <i class="fa fa-paper-plane intake-link-accent mr-2"></i>
      <p class="has-text-weight-semibold intake-link-accent mb-0">Next Step: Trigger Patient Intake</p>
    </div>
    <p class="intake-link-subtext mb-4">Send the intake form to your patient so they can begin their consultation.</p>

    <div class="intake-actions-grid">
      <label class="intake-link-label" for="intake-url"
        ><i class="fa fa-link intake-link-accent mr-2" aria-hidden="true"></i>Intake URL</label
      >
      <input
        id="intake-url"
        type="text"
        class="input intake-url-input"
        [value]="intakeUrl"
        readonly
        data-qa-id="Intake URL Input"
      />
      <button type="button" class="button is-outlined is-link" (click)="copyUrl()" data-qa-id="Copy Intake URL Button">
        <i class="fa" [ngClass]="copied ? 'fa-check' : 'fa-copy'"></i>
        <span class="ml-2">{{ copied ? 'Copied!' : 'Copy URL' }}</span>
      </button>

      <span class="intake-link-label"
        ><i class="fa fa-up-right-from-square intake-link-accent mr-2"></i>Open Intake Now</span
      >
      <span class="intake-link-subtext">Launch the intake form here for the patient</span>
      <button type="button" class="button is-link" (click)="openIntake()" data-qa-id="Open Intake Button">
        <i class="fa fa-up-right-from-square"></i>
        <span class="ml-2">Open Intake</span>
      </button>
    </div>
  </div>
</div>
